import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormControl, Validators, ValidationErrors, AbstractControl } from '@angular/forms';
import { FormResponse } from 'src/models/form-response';
import { AccountService } from 'src/app/services/account.service';
import { AlertBoxType } from '../base/alert-box/alertboxtype';
import { FormComponent } from '../base/form/form.component';

@Component({
  selector: 'app-settings-modal',
  templateUrl: './settings-modal.component.html',
  styleUrls: ['./settings-modal.component.scss']
})
export class SettingsModalComponent extends FormComponent implements OnInit {

  public changePasswordForm = new FormGroup({
    oldPassword: new FormControl('', [Validators.required]),
    newPassword: new FormControl('', [Validators.required, this.validatorPatternPassword]),
    confirmNewPassword: new FormControl('', [Validators.required, this.matchValues('newPassword')])
  });

  public formResponse: FormResponse;

  public alertBoxTypes = AlertBoxType;

  public submitDisabled = false;

  constructor(private accountService: AccountService, private changeDetector: ChangeDetectorRef) {
    super();
  }

  ngOnInit(): void {
  }

  get oldPassword() { return this.changePasswordForm.get('oldPassword'); }
  get newPassword() { return this.changePasswordForm.get('newPassword'); }
  get confirmNewPassword() { return this.changePasswordForm.get('confirmNewPassword'); }

  public onSubmit() {
    // TODO: Use EventEmitter with form value

    if (this.changePasswordForm.valid) {
      this.submitDisabled = true;

      this.accountService.changeOldPassword(this.oldPassword.value, this.newPassword.value).subscribe((result: FormResponse) => {
          this.formResponse = result;

          if (this.formResponse.result === true) {
            this.changePasswordForm.reset();
          }

          this.submitDisabled = false;

          this.changeDetector.detectChanges();
      });
    } else {
      this.oldPassword.markAsDirty();
      this.newPassword.markAsDirty();
      this.confirmNewPassword.markAsDirty();
    }
  }

  public hasErrors() {
    return this.formResponse !== undefined && this.formResponse.errors !== undefined && this.formResponse.errors.length > 0;
  }

}
